import { render, staticRenderFns } from "./TodoComponent.vue?vue&type=template&id=aabada00&scoped=true"
import script from "./TodoComponent.vue?vue&type=script&lang=js"
export * from "./TodoComponent.vue?vue&type=script&lang=js"
import style0 from "./TodoComponent.vue?vue&type=style&index=0&id=aabada00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabada00",
  null
  
)

export default component.exports